import React from "react";

 // Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// // Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "./styles.css";
import "./ourworksSlider.css";

// // import required modules
// // assets/images/paths/design.svg
import { Pagination, Navigation } from "swiper";


const OurworksSlider = () => {
  return (
    <div className="workslider">
      <div className="w-full sm:px-8 sm:py-0 md:p-0">
      <section>
          <Swiper
          slidesPerView={3}
          spaceBetween={30}
          slidesPerGroup={3}
          loop={false}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Pagination, Navigation]}
          breakpoints={
           {  
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                  slidesPerGroup: 1
                },
                // when window width is >= 480px
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  slidesPerGroup: 1
                },
                // when window width is >= 640px
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  slidesPerGroup: 2
                },
                // when window width is >= 640px
                1070: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                  slidesPerGroup: 3
                }
             } 
          }
          className="myWorkSwiper  p-none"
        >
          <SwiperSlide><img src="assets/images/كتاب لعبة المال أوفلاين.svg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="assets/images/TGAcademy.svg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="assets/images/محو الأمية.svg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="assets/images/تحدي الستين1.svg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="assets/images/تحدي الستين (1).svg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="assets/images/كتاب لعبة المال.svg" alt="" /></SwiperSlide>
        </Swiper>
      </section>
    </div>

  </div>
  )
}

export default OurworksSlider;